<template>
  <div>
    <el-button class="newAdd" @click="openDialog">合伙人迁移</el-button>
    <el-dialog
      title="合伙人迁移"
      :visible.sync="moveDialogVisible"
      width="45%"
      center
      @close="clear"
    >
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="UID" :label-width="formLabelWidth" prop="userId">
          <div class="search">
            <el-input
              v-model="form.userId"
              class="searchIpt"
              autocomplete="off"
            ></el-input>
            <el-button size="small" @click="searchById">查询</el-button>
          </div>
        </el-form-item>
        <el-form-item label="" :label-width="formLabelWidth" v-if="isAct">
          <div>查询信息</div>
          <div>用户UID: {{ detailInfo ? detailInfo.id : "" }}</div>
          <div>
            邮箱：{{ detailInfo ? detailInfo.email || detailInfo.tel : "" }}
          </div>
          <div>
            注册时间：
            <!-- {{
              new Date(detailInfo ? detailInfo.createTime : "").toLocaleString()
            }}
            ~~~ -->
            {{detailInfo ?(transferTime(detailInfo.createTime)): ""}}
            <!-- {{
              detailInfo
                ? moment(new Date(detailInfo.createTime).toLocaleString()).format("YYYY-MM-DD HH:mm:ss")
                : ""
            }} -->
          </div>
        </el-form-item>
        <el-form-item
          label="迁移至新上级合伙人"
          :label-width="formLabelWidth"
          prop="preUserId"
        >
          <el-input
            v-model="form.preUserId"
            class="searchIpt"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" :label-width="formLabelWidth" prop="remark">
          <el-input
            v-model="form.remark"
            class="searchIpt"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth">
          <div class="tip" style="color: red">
            注意：迁移至新上级合伙人后，该合伙人伞下的未结算盈亏会同步迁移至新上级合伙人伞下
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="add">迁移</el-button>
        <el-button size="small" @click="clearFiled">重置</el-button>
      </span>
      <!-- <span slot="footer" class="dialog-footer">
    <el-button @click="centerDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
  </span> -->
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      moveDialogVisible: false,
      detailInfo: null,
      isAct: false,
      form: {
        preUserId: "",
        userId: "",
        remark: "",
      },
      formLabelWidth: "150px",
      rules: {
        userId: [{ required: true, message: "请输入UID", trigger: "blur" }],
        preUserId: [
          { required: true, message: "请输入邀请人UID", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    ...mapActions("partnerList", ["movePartner", "getUserData"]),
    transferTime(time){
			var date = new Date(time);
			var Y = date.getFullYear() + '-'; 
			var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
			var D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' ';
			var h = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours()) + ':';
			var m = (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes());
			var s = (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds());
			var time1 = Y + M + D + h + m;
      return time1;
		},
    openDialog() {
      this.moveDialogVisible = true;
    },
    searchById() {
      if (this.form.userId == "" || this.form.userId == null) {
        this.$message.warning("请输入UID");
      } else {
        this.getUserData({ userId: this.form.userId }).then((res) => {
          console.log("getUserData", res);
          if (res.code == 0) {
            this.isAct = true;
            this.detailInfo = { ...res.data };
          } else {
            this.isAct = false;
          }
        });
      }
    },
    add() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.movePartner(this.form).then((res) => {
            if (res.code == 0) {
              if (res.data.code == 0) {
                this.$message.success("迁移成功");
                this.$emit("refresh");
                this.clear();
              } else {
                this.$message.error(res.data.msg || "迁移失败");
                this.clear();
              }
            } else {
              this.$message.error("迁移失败");
              this.clear();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    clearFiled() {
      this.$refs["form"].resetFields();
      this.isAct = false;
    },
    clear() {
      this.moveDialogVisible = false;
      this.$refs["form"].resetFields();
      this.isAct = false;
    },
  },
};
</script>

<style lang="less" src="../../../../styles/button.less" scoped>
.content {
  // border: 1px solid #f5f6f7;
  padding: 20px;
  width: 100%;
  height: 200px;
  .up {
    border: 1px solid #f5f6f7;
    width: 100%;
    height: 50%;
    display: flex;
  }
  .down {
    border: 1px solid #f5f6f7;
    width: 100%;
    height: 50%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .item {
    border-right: 1px solid #f5f6f7;
    display: flex;
    width: 50%;
    height: 100%;
    justify-content: center;
    align-items: center;
    .ipt {
      width: 90%;
    }
  }
}
.btn1 {
  display: flex;
  justify-content: center;
  width: 300px;
  margin: 0 auto;
}
.el-form-item__content {
  .tip {
    color: red;
  }
}
</style>
